var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPersonArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.54 21H1.54V22.5H22.54V21Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.5L5.69 2.56L7.63 4.5H1.5V6H7.63L5.69 7.94L6.75 9L10.5 5.25L6.75 1.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.54 19.61H21.04V17.35C21.04 16.75 20.8 16.18 20.38 15.76C19.96 15.34 19.39 15.1 18.79 15.1H15.79C15.19 15.1 14.62 15.34 14.2 15.76C13.78 16.18 13.54 16.75 13.54 17.35V19.61H12.04V17.35C12.04 16.36 12.44 15.4 13.14 14.7C13.84 14 14.8 13.6 15.79 13.6H18.79C19.78 13.6 20.74 14 21.44 14.7C22.14 15.4 22.54 16.36 22.54 17.35V19.61Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.29 6.36C17.74 6.36 18.17 6.49 18.54 6.74C18.91 6.99 19.2 7.34 19.37 7.75C19.54 8.16 19.58 8.61 19.5 9.05C19.41 9.49 19.2 9.89 18.88 10.2C18.57 10.51 18.16 10.73 17.73 10.82C17.29 10.91 16.84 10.86 16.43 10.69C16.02 10.52 15.67 10.23 15.42 9.86C15.17 9.49 15.04 9.05 15.04 8.61C15.04 8.01 15.28 7.44 15.7 7.02C16.12 6.6 16.69 6.36 17.29 6.36ZM17.29 4.86C16.55 4.86 15.82 5.08 15.21 5.49C14.59 5.9 14.11 6.49 13.83 7.17C13.55 7.86 13.47 8.61 13.62 9.34C13.76 10.07 14.12 10.74 14.65 11.26C15.17 11.78 15.84 12.14 16.57 12.29C17.3 12.43 18.05 12.36 18.74 12.08C19.43 11.8 20.01 11.32 20.42 10.7C20.83 10.08 21.05 9.36 21.05 8.62C21.05 7.63 20.65 6.67 19.95 5.97C19.25 5.27 18.29 4.87 17.3 4.87L17.29 4.86Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonArrow);
export default __webpack_public_path__ + "static/media/ic-person-arrow.e40d698a1d4a6121b946af4c579a7085.svg";
export { ForwardRef as ReactComponent };